import { memo } from 'react';

import { InceptIconProps } from './types/InceptIconProps';

const InceptIconComponent: React.FC<InceptIconProps> = ({
  children,
  viewBox,
  ...props
}: InceptIconProps) => (
  <svg {...props} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    {children}
  </svg>
);

export const InceptIcon = memo(InceptIconComponent);
